/**
 * PRÉVENIR LE SITE QUI NOUS HÉBERGE (2026-09-21, demande d'Emeni).
 *
 * Les tunnels publics (prise de rendez-vous, demande de devis) s'affichent dans une iframe posée sur le
 * site de l'établissement par `booking-widget.js` / `simulateur-widget.js`. Tout s'y passe à l'intérieur :
 * la page hôte n'avait donc aucun moyen de savoir qu'une demande venait d'aboutir, et ne pouvait
 * déclencher ni conversion Google Ads ni événement Analytics.
 *
 * D'où ce message, émis UNE FOIS, au moment où l'écran de confirmation s'affiche :
 *
 *     window.parent.postMessage({ source: 'iamani', type: 'devis-envoye', ... }, '*')
 *
 * Côté site client, l'écoute ressemble à :
 *
 *     window.addEventListener('message', (e) => {
 *       if (e.origin !== 'https://l-iamani.com') return;   // l'origine du <script> posé
 *       if (e.data?.source !== 'iamani' || e.data?.type !== 'devis-envoye') return;
 *       gtag('event', 'conversion', { ... });
 *     });
 *
 * DEUX RÈGLES À NE PAS PERDRE :
 *
 * 1. `'*'` comme destinataire est VOLONTAIRE. Chaque établissement héberge le widget sur son propre
 *    domaine : l'application ne connaît pas l'origine de la page hôte et ne peut donc pas la viser.
 *    C'est acceptable parce que le message ne transporte AUCUNE donnée personnelle — pas de nom, pas
 *    d'email, pas de téléphone, pas de montant. Ne jamais en ajouter : ce message est lisible par
 *    n'importe quel script de la page hôte, et par toute page qui nous encadrerait.
 * 2. `reference` est un identifiant technique opaque (dossier ou rendez-vous), utile seulement pour
 *    rapprocher plus tard une conversion d'une demande réelle. Il ne dit rien sur la personne.
 *
 * `window.parent` suffit : les deux widgets insèrent leur iframe directement dans la page hôte. Quand
 * la page n'est pas encadrée, `window.parent === window` et le message se perd sans rien casser.
 */

export type TypeAnnonce = 'devis-envoye';

export function annoncerAuSiteParent(type: TypeAnnonce, details: { parcours: 'simulateur' | 'rdv'; reference?: string | null }) {
    try {
        if (typeof window === 'undefined' || window.parent === window) return;
        window.parent.postMessage({
            source: 'iamani',
            type,
            // Permet au site client de distinguer les deux tunnels s'il le souhaite, sans l'y obliger :
            // un seul filtre sur `type` suffit pour compter toutes les demandes.
            parcours: details.parcours,
            ...(details.reference ? { ref: String(details.reference) } : {}),
        }, '*');
    } catch (e) {
        // Un site hôte exotique ne doit jamais empêcher le visiteur de voir sa confirmation.
    }
}
